export const getCurrentDate = () => {
  const today = new Date();

  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  const day = today.getDate().toString().padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

export const getCurrentFinancialYear = () => {
  const today = new Date();
  const currentMonth = today.getMonth(); // 0-indexed (0 for January, 3 for April)
  const currentYear = today.getFullYear();

  // A financial year starts in April. If the current month is before April (Jan-Mar),
  // then the financial year started in the previous calendar year.
  const financialYearStart = currentMonth < 3 ? currentYear - 1 : currentYear;

  const fromDate = `${financialYearStart}0401`;
  const toDate = `${financialYearStart + 1}0331`;

  return { fromDate, toDate };
};
